// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__Jq59i","active":"PopoverSharedStyle_active__VVTGy","backdrop":"PopoverSharedStyle_backdrop__JsoL5"};